import { IProjectLink } from '@api/models/project-links.model';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export const getAllProjectLinks = async (clientId: string, projectId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/project-links`
    );
    return data as IProjectLink[];
};

export const getLinkById = async (clientId: string, projectId: string, linkId: string) => {
    const { data, status } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/project-links/${linkId}`
    );
    return { data, status };
};

export const addLink = async (clientId: string, projectId: string, payload: any) => {
    const { data, status } = await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/project-links`,
        payload
    );
    return { data, status };
};

export const updateLink = async (clientId: string, projectId: string, linkId: string, payload: any) => {
    const { data, status } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/project-links/${linkId}`,
        payload
    );
    return { data, status };
};
